import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mmb-web-app-add-experience-info',
  templateUrl: './add-experience-info.component.html',
  styleUrls: ['./add-experience-info.component.scss']
})
export class AddExperienceInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
